'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setStepValidation = setStepValidation;
exports.getStepValidation = getStepValidation;
exports.setContainerValidation = setContainerValidation;
exports.getContainerValidation = getContainerValidation;
exports.setComponentValidation = setComponentValidation;
exports.getComponentValidation = getComponentValidation;

var _dateFns = require('date-fns');

var _reactRedux = require('react-redux');

var _metrixCommon = require('metrix-common');

function setStepValidation(step, returns, dynamicDate) {

    if (step.containers && step.containers.length > 0) {
        step.containers.forEach(function (container, i, containers) {
            return containers[i] = setContainerValidation(container, returns, dynamicDate);
        });
    }

    return step;
}

function getStepValidation(step) {
    var valid = true;

    if (step.containers && step.containers.length > 0) {
        step.containers.forEach(function (container) {
            if (valid) valid = getContainerValidation(container, valid);
        });
    }

    return valid;
}

function setContainerValidation(container, returns, dynamicDate) {
    if (container.containers && container.containers.length > 0) {
        container.containers.forEach(function (nestedContainer, i, containers) {
            return containers[i] = setContainerValidation(nestedContainer, returns, dynamicDate);
        });
    } else {
        container.components.forEach(function (component, i, components) {
            return components[i] = setComponentValidation(component, returns, dynamicDate);
        });
    }

    var existingTableGroupComponent = container.components.find(function (el) {
        return el.type === 'tableGroup';
    });
    if (existingTableGroupComponent) {
        var existingValidationResultElement = existingTableGroupComponent.elements.find(function (el) {
            return el.code === 'ValidationBanner';
        });
        if (existingValidationResultElement && existingValidationResultElement.elements && existingValidationResultElement.elements.length > 0) {
            var existingValidationResultComponent = container.components.find(function (el) {
                return el.code === 'ValidationBanner';
            });
            if (existingValidationResultComponent) {
                existingValidationResultComponent.elements = [{
                    "code": "Text",
                    "value": existingValidationResultElement.elements[0].elements[0].value
                }, {
                    "code": "Alignment",
                    "value": "left"
                }, {
                    "code": "Top",
                    "value": "small"
                }, {
                    "code": "visible",
                    "value": true
                }];
            } else {
                var lastComponent = container.components[container.components.length - 1];
                container.components[container.components.length - 1] = {
                    "code": "ValidationBanner",
                    "type": "validationBanner",
                    "elements": [{
                        "code": "Text",
                        "value": existingValidationResultElement.elements[0].elements[0].value
                    }, {
                        "code": "Alignment",
                        "value": "left"
                    }, {
                        "code": "Top",
                        "value": "small"
                    }, {
                        "code": "visible",
                        "value": true
                    }]
                };
                container.components.push(lastComponent);
            }
        } else {
            container.components = container.components.filter(function (component) {
                return component.code !== "ValidationBanner";
            });
        }
    }

    return container;
}

function getContainerValidation(container, valid) {
    if (!valid) valid = true;

    if (container.containers && container.containers.length > 0) {
        container.containers.forEach(function (nestedContainer) {
            if (valid) valid = getContainerValidation(nestedContainer, valid);
        });
    } else {
        container.components.forEach(function (component) {
            if (valid) valid = getComponentValidation(component);
        });
    }

    return valid;
}

function setComponentValidation(component, returns, dynamicDate) {
    var payload = getReturnByCode(component.code, returns);

    var required = (0, _metrixCommon.getElementValueByCode)(component.elements, 'Required');

    var visible = (0, _metrixCommon.getElementValueByCode)(component.elements, 'visible');

    if (required && required === 'no') {
        component = setValidationElement(component, true);
    } else if (visible === false) {
        component = setValidationElement(component, true);
    } else {
        switch (component.type) {
            case 'fileUploader':
                component = setValidationElement(component, validateFileUploaderComponent(component, payload));
                break;
            case 'checkbox':
                component = setValidationElement(component, validateCheckboxComponent(component, payload));
                break;
            case 'name':
                component = setValidationElement(component, validateNameComponent(component, payload));
                break;
            case 'date':
                component = setValidationElement(component, validateDateComponent(component, payload, dynamicDate));
                break;
            case 'dateRange':
                component = setValidationElement(component, validateDateRangeComponent(component, returns));
                break;
            case 'input':
                component = setValidationElement(component, validateInputComponent(component, payload));
                break;
            case 'valueFrequency':
                component = setValidationElement(component, validateValueFrequencyComponent(payload));
                break;
            case 'dropDown':
                component = setValidationElement(component, validateDropdownComponent(payload));
                break;
            case 'classification':
                component = setValidationElement(component, validateClassification(payload));
                break;
            case 'location':
            case 'locationAutocomplete':
                component = setValidationElement(component, validateAddressComponent(payload));
                break;
            case 'placeAutocomplete':
                component = setValidationElement(component, validatePlaceComponent(payload));
                break;
            case 'customPlaceAutocomplete':
                component = setValidationElement(component, validateCustomPlaceComponent(payload));
                break;
            case 'phone':
                component = setValidationElement(component, validatePhoneComponent(component, payload));
                break;
            case 'summary':
                component = setValidationElement(component, validateSummaryComponent(component, payload));
                break;
            case 'documentUpload':
                component = setValidationElement(component, validateDocumentUploadComponent(payload));
                break;
            case 'listGroup':
                component = setValidationElement(component, validateListGroupComponent(component, payload));
                break;
            case 'radio':
                component = setValidationElement(component, validateRadioComponent(payload));
                break;
            case 'switch':
                component = setValidationElement(component, validateSwitchComponent(component, payload));
                break;
            case 'usageGroup':
                component = setValidationElement(component, validateUsageGroupComponent(component, payload));
                break;
            case 'tableGroup':
                component = setValidationElement(component, validateTableGroupComponent(component, payload));
                break;
        }
    }

    return component;
}

function getComponentValidation(component) {
    var valid = true;

    if (component && component.elements && component.elements.some(function (x) {
        return x.code === 'valid';
    })) {
        valid = component.elements.find(function (x) {
            return x.code === 'valid';
        }).value;
    }

    return valid;
}

var validateCustomPlaceComponent = function validateCustomPlaceComponent(payload) {
    return assertReturnElement(payload, 'Value');
};

var validateFileUploaderComponent = function validateFileUploaderComponent(component, payload) {
    var required = (0, _metrixCommon.getElementValueByCode)(component.elements, 'Required') && (0, _metrixCommon.getElementValueByCode)(component.elements, 'Required') === 'yes';

    return required ? assertReturnElement(payload, 'InitialFiles') : true;
};

var validateTableGroupComponent = function validateTableGroupComponent(component, payload) {
    var allValid = true;

    function findAllComponents(node) {
        var components = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        var codesToExclude = ['TableHeader', 'Rules', 'Value', 'Options', 'Columns', 'Entities', 'Entity', 'Label'];
        if (node.code && !codesToExclude.includes(node.code)) {
            components.push(node);
            if (node.elements && node.elements.length > 0) {
                node.elements.forEach(function (child) {
                    return findAllComponents(child, components);
                });
            }
        }
        return components;
    }

    function findComponentByCode(code, components) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = components[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _component = _step.value;

                if (_component.code === code) {
                    return _component;
                }
                if (_component.components) {
                    var result = findComponentByCode(code, _component.components);
                    if (result) {
                        return result;
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return null;
    }

    function validateElements(elements, components) {
        elements.forEach(function (element) {
            var componentDef = findComponentByCode(element.code, components);
            if (componentDef && componentDef.elements) {
                var requiredElement = componentDef.elements.find(function (el) {
                    return el.code === 'Required';
                }) && componentDef.elements.find(function (el) {
                    return el.code === 'Required';
                }).value === 'yes';
                var hiddenElement = componentDef.elements.find(function (el) {
                    return el.code === 'IsHidden';
                }) && componentDef.elements.find(function (el) {
                    return el.code === 'IsHidden';
                }).value === 'true';
                var actuallyIsntHidden = Boolean(element.ActuallyIsntHidden);

                if (!requiredElement || hiddenElement && !actuallyIsntHidden) return;

                var _isValid = false;

                switch (componentDef.type) {
                    case "slider":
                    case "input":
                        _isValid = validateInputComponent(componentDef, element);
                        break;
                    case "locationAutocomplete":
                        _isValid = validateAddressComponent(element);
                        break;
                    case "dropDown":
                        _isValid = validateDropdownComponent(element);
                        break;
                    case 'switch':
                        _isValid = validateSwitchComponent(componentDef, element);
                        break;
                }
                allValid = allValid && _isValid;
            }

            if (element.elements) {
                validateElements(element.elements, components);
            }
        });
    }

    var allComponents = findAllComponents(payload);
    validateElements(allComponents, component.components);

    var resultByValidationConditions = validateByValidationConditions(payload, component);

    if (resultByValidationConditions && resultByValidationConditions.elements && resultByValidationConditions.elements.length > 0) {
        allValid = false;

        var existingValidationResultElement = component.elements.find(function (el) {
            return el.code === resultByValidationConditions.code;
        });
        if (existingValidationResultElement) {
            existingValidationResultElement.elements = resultByValidationConditions.elements;
        } else {
            component.elements.push(resultByValidationConditions);
        }
    } else {
        component.elements = component.elements.filter(function (el) {
            return el.code !== resultByValidationConditions.code;
        });
    }

    allValid = validateEntitiesMinCount(component, payload, allValid);

    return allValid;
};

function validateEntitiesMinCount(component, payload, allValid) {
    var isRules = Boolean(component.elements.find(function (el) {
        return el.code === 'Rules';
    }));
    var rules = isRules && component.elements.find(function (el) {
        return el.code === 'Rules';
    }).elements;
    var hasMinCount = isRules && rules.some(function (el) {
        return el.code === 'MinCount';
    });
    var minCount = hasMinCount && Number(rules.find(function (el) {
        return el.code === 'MinCount';
    }).value);

    if (hasMinCount) {
        var tableEntities = payload && Array.isArray(payload.elements) && payload.elements.find(function (el) {
            return el.code === 'Entities';
        });
        var tableData = tableEntities && tableEntities.elements;

        if (!tableData || minCount > tableData.length) {
            allValid = false;
        }
    }

    return allValid;
}

function validateCheckboxComponent(component, payload) {
    var valid = false;

    var required = false;

    if ((0, _metrixCommon.getElementValueByCode)(component.elements, 'Required') && (0, _metrixCommon.getElementValueByCode)(component.elements, 'Required') === 'yes') {
        required = true;
    }

    if (required) {
        valid = assertReturnElement(payload, 'Value') && (0, _metrixCommon.getReturnElementByCode)(payload, 'Value') === 'true';
    } else {
        valid = true;
    }

    return valid;
}

function validateSwitchComponent(component, payload) {
    var valid = false;

    var required = false;

    if ((0, _metrixCommon.getElementValueByCode)(component.elements, 'Required') && (0, _metrixCommon.getElementValueByCode)(component.elements, 'Required') === 'yes') {
        required = true;
    }

    if (required) {
        valid = assertReturnElement(payload, 'Value') && (0, _metrixCommon.getReturnElementByCode)(payload, 'Value') === 'true';
    } else {
        valid = true;
    }

    return valid;
}

function validateNameComponent(component, payload) {
    var isGenderRequired = (0, _metrixCommon.getElementValueByCode)(component.elements, 'AddGender') === 'yes';

    var validGender = isGenderRequired ? assertReturnElement(payload, 'Gender') : true;
    var validFirstName = assertReturnElement(payload, 'FirstName');
    var validLastName = assertReturnElement(payload, 'LastName');

    setElementValidState(component, 'Gender', validGender);
    setElementValidState(component, 'FirstName', validFirstName);
    setElementValidState(component, 'LastName', validLastName);

    return validGender && validFirstName && validLastName;
}

function validateDateComponent(component, payload, dynamicDate) {
    var validDay = assertReturnElement(payload, 'Day');
    var validMonth = assertReturnElement(payload, 'Month');
    var validYear = assertReturnElement(payload, 'Year');

    setElementValidState(component, 'Day', validDay);
    setElementValidState(component, 'Month', validMonth);
    setElementValidState(component, 'Year', validYear);

    var valid = validDay && validMonth && validYear;
    if (!valid) return false;

    var date = getDateFromReturn(payload);

    valid = (0, _dateFns.isValid)(date);
    if (!valid) return false;

    var mode = (0, _metrixCommon.getElementValueByCode)(component.elements, 'Mode');
    var take = Number((0, _metrixCommon.getElementValueByCode)(component.elements, 'Take') || 0);
    var skip = Number((0, _metrixCommon.getElementValueByCode)(component.elements, 'Skip') || 0);
    var selector = (0, _metrixCommon.getElementValueByCode)(component.elements, 'Selector');
    var dynamicTimestamp = dynamicDate ? Date.parse(dynamicDate) : 0;
    var currentDate = dynamicTimestamp || new Date().setHours(0, 0, 0, 0);

    if (take || skip) {
        if (!selector) selector = 'year';
    }

    var minDate = date;
    var maxDate = date;

    if (mode === 'future') {
        valid = (0, _dateFns.isFuture)(date) || (0, _dateFns.isToday)(date) || (0, _dateFns.isPast)(date);
        if (!valid) return false;

        if (skip) {
            switch (selector) {
                case 'year':
                    minDate = (0, _dateFns.addYears)(currentDate, skip);
                    break;
                case 'month':
                    minDate = (0, _dateFns.addMonths)(currentDate, skip);
                    break;
                case 'day':
                    minDate = (0, _dateFns.addDays)(currentDate, skip);
                    break;
            }
            valid = (0, _dateFns.isAfter)(date, minDate);
            if (!valid) return false;
        }

        if (take) {
            switch (selector) {
                case 'year':
                    maxDate = (0, _dateFns.addYears)(currentDate, take + skip);
                    break;
                case 'month':
                    maxDate = (0, _dateFns.addMonths)(currentDate, take + skip);
                    break;
                case 'day':
                    maxDate = (0, _dateFns.addDays)(currentDate, take + skip);
                    break;
            }
            maxDate = (0, _dateFns.addDays)(maxDate, 1);

            valid = (0, _dateFns.isBefore)(date, maxDate);
            if (!valid) return false;
        }
    }

    if (mode === 'past') {
        valid = (0, _dateFns.isPast)(date);
        if (!valid) return false;

        if (skip) {
            switch (selector) {
                case 'year':
                    maxDate = (0, _dateFns.addYears)(currentDate, skip * -1);
                    break;
                case 'month':
                    maxDate = (0, _dateFns.addMonths)(currentDate, skip * -1);
                    break;
                case 'day':
                    maxDate = (0, _dateFns.addDays)(currentDate, skip * -1);
                    break;
            }
            valid = (0, _dateFns.isBefore)(date, maxDate) || (0, _dateFns.isEqual)(date, maxDate);
            if (!valid) return false;
        }

        if (take) {
            take = take + (skip || 0);
            switch (selector) {
                case 'year':
                    minDate = (0, _dateFns.addYears)(currentDate, take * -1);
                    break;
                case 'month':
                    minDate = (0, _dateFns.addMonths)(currentDate, take * -1);
                    break;
                case 'day':
                    minDate = (0, _dateFns.addDays)(currentDate, take * -1);
                    break;
            }
            minDate = (0, _dateFns.addDays)(minDate, -1);

            valid = (0, _dateFns.isAfter)(date, minDate);
            if (!valid) return false;
        }
    }

    return valid;
}

function validateDateRangeComponent(component, returns) {
    var start = getReturnByCode(component.code + 'Start', returns);
    var end = getReturnByCode(component.code + 'End', returns);
    var valid = false;

    if (start && end) {
        var startDate = getDateFromReturn(start);
        var endDate = getDateFromReturn(end);

        valid = (0, _dateFns.isAfter)(endDate, startDate);
    }

    return valid;
}

function getDateFromReturn(payload) {
    var valid = assertReturnElement(payload, 'Month') && assertReturnElement(payload, 'Day') && assertReturnElement(payload, 'Year');

    var date = null;

    if (valid) {
        date = new Date((0, _metrixCommon.getElementValueByCode)(payload.elements, 'Year'), (0, _metrixCommon.getElementValueByCode)(payload.elements, 'Month') - 1, (0, _metrixCommon.getElementValueByCode)(payload.elements, 'Day'));
    }

    return date;
}

function validateInputComponent(component, payload) {
    var valid = false;

    var required = true;

    if ((0, _metrixCommon.getElementValueByCode)(component.elements, 'Required') && (0, _metrixCommon.getElementValueByCode)(component.elements, 'Required') === 'no') {
        required = false;
    }

    if (required) {
        valid = assertReturnElement(payload, 'Value');
    } else if (!required && (0, _metrixCommon.getElementValueByCode)(component.elements, 'ValueType') === 'Phone' && (0, _metrixCommon.getReturnElementByCode)(payload, 'Value')) {
        valid = isValidPhoneNumber((0, _metrixCommon.getReturnElementByCode)(payload, 'Value'));
    } else {
        valid = true;
    }

    if ((0, _metrixCommon.getElementValueByCode)(component.elements, 'Options')) {
        valid = valid && assertReturnElement(payload, 'Quantifier') && assertReturnElement(payload, 'Label');
    }

    if ((0, _metrixCommon.getElementValueByCode)(component.elements, 'ValueType')) {
        var valueType = (0, _metrixCommon.getElementValueByCode)(component.elements, 'ValueType');
        var overrideMinLength = parseInt((0, _metrixCommon.getElementValueByCode)(component.elements, 'OverrideMinLength'));
        var value = (0, _metrixCommon.getReturnElementByCode)(payload, 'Value');

        if (required && valueType === 'Email') {
            valid = valid && (0, _metrixCommon.validateEmail)(value);
        }
        if (required && valueType === 'Phone') {
            valid = valid && isValidPhoneNumber(value);
        }
        if (value && ['number', 'text'].includes(valueType.toLowerCase()) && !isNaN(overrideMinLength) && overrideMinLength > 0) {
            var inputLength = value.toString().length;
            valid = valid && inputLength >= overrideMinLength;
        }

        if (value && ['number', 'currency', 'percent'].includes(valueType.toLowerCase())) {
            var maxValue = parseInt((0, _metrixCommon.getElementValueByCode)(component.elements, 'MaxValue'), 10);
            var minValue = parseInt((0, _metrixCommon.getElementValueByCode)(component.elements, 'MinValue'), 10);
            var numericValue = parseInt(value.replace(/[^0-9.-]/g, ''), 10);

            if (!isNaN(numericValue)) {
                if (!isNaN(minValue)) {
                    valid = valid && numericValue >= minValue;
                }
                if (!isNaN(maxValue)) {
                    valid = valid && numericValue <= maxValue;
                }
            }
        }
    }

    return valid;
}

function validateDropdownComponent(payload) {
    var valid = assertReturnElement(payload, 'Value');

    return valid;
}

function validateClassification(payload) {
    var valid = false;
    var elements = payload.elements;
    var totalPercentage = 0;

    if (elements && elements.length > 0) {
        elements.map(function (x) {
            return x.elements[2] && (totalPercentage += parseInt(x.elements[2].value, 10));
        });
    }

    totalPercentage === 100 ? valid = true : valid = false;

    return valid;
}

function validateAddressComponent(payload) {

    var valid = assertReturnElement(payload, 'Code');

    if (valid) {
        var mode = (0, _metrixCommon.getReturnElementByCode)(payload, 'Code');

        if (mode === 'MANUAL') {
            valid = assertReturnElement(payload, 'StreetNumber') && assertReturnElement(payload, 'Street') && assertReturnElement(payload, 'City') && assertReturnElement(payload, 'State') && assertReturnElement(payload, 'StateCode') && assertReturnElement(payload, 'Country') && assertReturnElement(payload, 'CountryCode') && assertReturnElement(payload, 'PostalCode') && isValidPostalCode((0, _metrixCommon.getReturnElementByCode)(payload, 'PostalCode'), (0, _metrixCommon.getReturnElementByCode)(payload, 'CountryCode'));
        } else if (mode === 'INTERNATIONAL') {
            valid = assertReturnElement(payload, 'StreetNumber') && assertReturnElement(payload, 'Street') && assertReturnElement(payload, 'City') && assertReturnElement(payload, 'State') && assertReturnElement(payload, 'Country') && assertReturnElement(payload, 'CountryCode') && assertReturnElement(payload, 'PostalCode') && isValidPostalCode((0, _metrixCommon.getReturnElementByCode)(payload, 'PostalCode'), (0, _metrixCommon.getReturnElementByCode)(payload, 'CountryCode'));
        } else {
            valid = assertReturnElement(payload, 'PostalCode') && isValidPostalCode((0, _metrixCommon.getReturnElementByCode)(payload, 'PostalCode'), (0, _metrixCommon.getReturnElementByCode)(payload, 'CountryCode')) && assertReturnElement(payload, 'FormattedAddress');
        }
    }
    return valid;
}

function validatePlaceComponent(payload) {

    var valid = assertReturnElement(payload, 'Code') && assertReturnElement(payload, 'BusinessName');

    return valid;
}

function isValidPostalCode(value, countryCode) {

    if (String(countryCode).toLowerCase() === 'usa') {
        return new RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/).test(value);
    } else {
        return new RegExp(/^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z] [0-9][ABCEGHJ-NPRSTV-Z][0-9]$/).test(value);
    }
}

function validatePhoneComponent(component, payload) {
    var areaCode = (0, _metrixCommon.getReturnElementByCode)(payload, 'AreaCode');
    var validAreaCode = assertReturnElement(payload, 'AreaCode') && areaCode.length === 3 && isValidPhoneNumber(areaCode, 'AreaCode');

    var phoneNumber = (0, _metrixCommon.getReturnElementByCode)(payload, 'Number');
    var validNumber = assertReturnElement(payload, 'Number') && phoneNumber.length === 7 && isValidPhoneNumber(phoneNumber, 'Number');

    setElementValidState(component, 'AreaCode', validAreaCode);
    setElementValidState(component, 'Number', validNumber);

    return validAreaCode && validNumber;
}

function isValidPhoneNumber(value, type) {
    var regEx = void 0;

    switch (type) {
        case 'AreaCode':
            regEx = /^([2-9]\d{2})$/;
            break;
        case 'Number':
            regEx = /^([2-9]\d{6})$/;
            break;
        default:
            regEx = /^([2-9]\d{9})$/;
            break;
    }

    return regEx.test(value);
}

function validateSummaryComponent(component, payload) {
    var valid = true;

    var required = true;

    if (component && component.elements && component.elements.some(function (el) {
        return el.code === 'Required';
    })) {
        var value = component.elements.find(function (el) {
            return el.code === 'Required';
        }).value;
        if (value === 'no') {
            required = false;
        }
    }

    var entities = payload && payload.elements && payload.elements.find(function (el) {
        return el.code === 'Entities';
    });

    if (required && entities) {
        entities.elements.forEach(function (el) {
            var status = (0, _metrixCommon.getElementValueByCode)(el.elements, 'Status');

            if (status !== 'Complete') {
                valid = false;
            }
        });
    } else if (required && !entities) {
        valid = false;
    }

    return valid;
}

function validateDocumentUploadComponent(payload) {
    var valid = false;

    if (payload && payload.elements && (0, _metrixCommon.getElementValueByCode)(payload.elements, 'Count') > 0) {
        valid = true;
    }

    return valid;
}

function validateListGroupComponent(component, payload) {
    var valid = false;

    var limit = (0, _metrixCommon.getElementValueByType)(component.elements, 'Limit');
    var nullOption = (0, _metrixCommon.getElementValueByCode)(component.elements, 'NoneOption');

    if (nullOption && (!payload || payload && payload.elements && payload.elements.length === 0)) {
        valid = true;
    } else if (limit) {
        if (payload && payload.elements && payload.elements.length > 0 && payload.elements.length <= parseInt(limit)) {
            valid = true;
        }
    } else if (payload && payload.elements && payload.elements.length > 0) {
        valid = true;
    }

    return valid;
}

function validateRadioComponent(payload) {
    //let valid = assertReturnElement(payload, `Value`);
    var valid = true;

    return valid;
}

function validateUsageGroupComponent(component, payload) {
    var valid = true;
    var limit = (0, _metrixCommon.getElementValueByCode)(component.elements, 'Limit');
    if (limit) {
        limit = parseInt(limit);
    }
    if (payload.elements && payload.elements.length > 0) {
        payload.elements.map(function (equipment) {
            var operators = (0, _metrixCommon.getElementsByCode)(equipment.elements, 'Operators');
            var usage = 0;
            if (operators && operators.length > 0) {
                operators.map(function (operator) {
                    var operatorUsage = (0, _metrixCommon.getElementValueByCode)(operator.elements, 'Value');
                    if (operatorUsage) {
                        operatorUsage = parseInt(operatorUsage);
                        usage += operatorUsage;
                    }
                });
                if (usage !== limit) {
                    valid = false;
                }
            } else {
                valid = false;
            }
        });
    } else {
        valid = false;
    }
    return valid;
}

function validateByValidationConditions(payload, component) {
    function getAllElementsByCode(node, code) {
        var resultElements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        if (node && Array.isArray(node) && node.length > 0) {
            node.forEach(function (child) {
                return getAllElementsByCode(child, code, resultElements);
            });
        } else {
            if (node.code === code) {
                resultElements.push(node);
            }

            if (node.elements && node.elements.length > 0) {
                node.elements.forEach(function (child) {
                    return getAllElementsByCode(child, code, resultElements);
                });
            }
        }

        return resultElements;
    }

    function updateOrCreateElement(destinationArray, code, sourceObject) {
        var existingElement = destinationArray.find(function (el) {
            return el.code === code;
        });

        if (existingElement) {
            // Update existing element
            existingElement.elements.push({
                'code': sourceObject.code,
                'value': sourceObject.elements[0].value
            });
        } else {
            // Create new element
            destinationArray.push({
                'code': code,
                'elements': [{
                    'code': sourceObject.code,
                    'value': sourceObject.elements[0].value
                }]
            });
        }
    }

    function sumNumbers(elements) {
        // Ensure that the input is an array
        if (!Array.isArray(elements)) {
            throw new Error('Input must be an array of objects');
        }

        var sum = elements.reduce(function (accumulator, element) {
            var numValue = 0;
            var currentValueElement = element.elements.find(function (x) {
                return x.code === 'Value';
            });
            if (currentValueElement && currentValueElement.value) {
                numValue = parseFloat(currentValueElement.value);
            }

            if (!isNaN(numValue)) {
                return accumulator + numValue;
            } else {
                return accumulator;
            }
        }, 0);

        return sum;
    }

    var result = {
        "code": "ValidationBanner",
        "elements": []
    };

    if (component && component.type === 'tableGroup' && component.elements && payload && payload.elements) {
        var validationElements = (0, _metrixCommon.getElementsByCode)(component.elements, 'Validations');

        if (validationElements) {
            var columnElements = getAllElementsByCode(payload, 'Columns');

            validationElements.forEach(function (propertyValidation) {
                var currentPropertyElements = getAllElementsByCode(columnElements, propertyValidation.code);
                if (currentPropertyElements) {
                    propertyValidation.elements.forEach(function (rule) {
                        switch (rule.code) {
                            case "Max":
                                if (sumNumbers(currentPropertyElements) > parseFloat(rule.value)) {
                                    updateOrCreateElement(result.elements, propertyValidation.code, rule);
                                }
                                break;
                            case "Min":
                                if (sumNumbers(currentPropertyElements) < parseFloat(rule.value)) {
                                    updateOrCreateElement(result.elements, propertyValidation.code, rule);
                                }
                                break;
                            case "Equal":
                                if (sumNumbers(currentPropertyElements) !== parseFloat(rule.value)) {
                                    updateOrCreateElement(result.elements, propertyValidation.code, rule);
                                }
                                break;
                        }
                    });
                }
            });
        }
    }
    //TODO Implement errors for each entity
    //else if (component && component.type == 'table' && component.elements) {

    //}

    return result;
}

function setValidationElement(component, valid) {
    if (!component.elements) {
        component.elements = [];
    }

    if (component.elements.some(function (x) {
        return x.code === 'valid';
    })) {
        component.elements.find(function (x) {
            return x.code === 'valid';
        }).value = valid;
    } else {
        component.elements.push({ code: 'valid', value: valid });
    }

    return component;
}

function setElementValidState(component, code, valid) {
    if (!component.elements) {
        component.elements = [];
    }

    if (component.elements.some(function (x) {
        return x.code === 'valid' + code;
    })) {
        component.elements.find(function (x) {
            return x.code === 'valid' + code;
        }).value = valid;
    } else {
        component.elements.push({ code: 'valid' + code, value: valid });
    }

    return valid;
}

function getReturnByCode(code, returns) {
    var payload = null;

    if (returns && returns.length > 0 && returns.some(function (x) {
        return x.code === code;
    })) {
        payload = returns.find(function (x) {
            return x.code === code;
        });
    }

    return payload;
}

function assertReturnElement(payload, code) {
    var assert = false;

    if (payload && payload.elements && payload.elements.length > 0 && payload.elements.some(function (x) {
        return x.code === code;
    }) && payload.elements.find(function (x) {
        return x.code === code;
    }).value && (payload.elements.find(function (x) {
        return x.code === code;
    }).value.length > 0 || !isNaN(payload.elements.find(function (x) {
        return x.code === code;
    }).value))) {
        assert = true;
    }

    return assert;
}

var mapStateToProps = function mapStateToProps(state) {
    return {
        dynamicDate: state.workflow.dynamicDate
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(setStepValidation);